export class Consumer {
  ID: string;
  Name: string; // title
  Suffix: string;
  Aktiv: number;
}
